<template>
    <div class="loading-overlay" :class="{'loading-overlay-cover': coverBody}" :style="styles">
        <div class="spinner">
            <LoadingSpinner v-if="loadingProgress < 100" :loadingProgress="loadingProgress"></LoadingSpinner>
            <i v-else class="fa fa-2x fa-check text-success"></i>
        </div>
        <ProgressBar
            :progress="loadingProgress"
            :hideZero="true"
        ></ProgressBar>
    </div>
</template>
<script>

    import ProgressBar from "./ProgressBar";
    import LoadingSpinner from "./LoadingSpinner";

    export default {
        name: 'LoadingOverlay',
        components: {
            ProgressBar,
            LoadingSpinner
        },
        data() {
            return {};
        },
        computed: {
            styles() {
                const styles = {};
                if (this.opaque) {
                    styles['background-color'] = 'rgba(0, 0, 0, 1)';
                }
                return styles;
            }
        },
        props     : {
            loadingProgress: {
                type: Number,
                default: null,
            },
            coverBody: {
                type: Boolean,
                default: false,
            },
            opaque: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>
